module.exports = __webpack_public_path__ + "img/star-filled.7dc6e5d5.svg";